var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "7",
        height: "10",
        viewBox: "0 0 7 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M2.82841 4.94972L6.36391 1.41421L4.94969 0L0 4.9497L4.94969 9.89946L6.36392 8.48531L2.82841 4.94972Z",
          fill: "#4F58F5",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }